export default "__VITE_ASSET__Yt99fcsN__"